import { render, staticRenderFns } from "./AgentDetailsAccess.vue?vue&type=template&id=a4251f7e"
import script from "./AgentDetailsAccess.vue?vue&type=script&lang=js"
export * from "./AgentDetailsAccess.vue?vue&type=script&lang=js"
import style0 from "./AgentDetailsAccess.vue?vue&type=style&index=0&id=a4251f7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports